import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import RenderSections from '@/components/probaworkflows_base_components/RenderMainSections/RenderMainSections.vue';
import {
  GET_ASSIGNED_WIDGETS,
  get_headers,
  GET_TABS,
  EDIT_ENTITY_NAME_URL,
  GET_APPLICATION_STATUS
} from '@/utils/constants/constants';
import alert_mixin from '@/utils/mixins/alert_mixin';
import EntityDocuments from "@/views/probaworkflows_base/entity/entity_applications/entity_documents/EntityDocuments.vue";
import RequestedInformationUpdate from "@/views/probaworkflows_base/entity/requested_information/requested_infomation_update/RequestedInformationUpdate.vue";
import ViewComplianceChecks from '@/views/probaworkflows_base/management/compliance_management/view_compliance_checks/ViewComplianceChecks.vue';
import ESigning from '@/views/probaworkflows_base/management/template_managment/e_signing/ESigning.vue';
import VerificationOverview from '@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_overview/VerificationOverview.vue';
import axios from 'axios';
import ApplicationOverviewDetails from "../application_overview_details/ApplicationOverviewDetails.vue";
import EntityInvoiceOverview from "../entity_invoice_overview/EntityInvoiceOverview.vue";
import EntityVerificationResults from "../entity_verification_results/EntityVerificationResults.vue";
export default {
  name: 'ApplicationOverview',
  mixins: [alert_mixin],
  components: {
    NavigationBackButton,
    ApplicationOverviewDetails,
    EntityInvoiceOverview,
    ESigning,
    VerificationOverview,
    RequestedInformationUpdate,
    ViewComplianceChecks,
    EntityDocuments,
    RenderSections,
    EntityVerificationResults
  },
  data: () => ({
    active_tab: 'overview',
    application_status: "",
    requests: [],
    dropdown_expanded: false,
    selectedDropdown: 'overview',
    headers: get_headers(),
    visible_tabs: [],
    db_tabs: [],            // dynamic "main section" tabs
    dropdownOptions: {},
    application_form_id: null,
    entity_name: sessionStorage.getItem('entity_name' ), // Add entity_name to data
    show_edit_entity_modal: false,
    current_edit_entity: {
      first_name: '',
      last_name: ''
    },
  }),
  computed: {
    application_id() { return this.get_id_from_route_or_storage('application_id'); },
    entity_profile_id() { return this.get_id_from_route_or_storage('entity_profile_id'); },
    profile_role_form_id() { return this.get_id_from_route_or_storage('profile_role_form_id'); },
    status_from_route() { return sessionStorage.getItem('application_status') || ""; },
    content_type() {
      if (this.is_db_main_section_tab(this.active_tab)) return 'dynamic';
      if (this.active_tab === 'Overview') return 'Overview';
      if (this.active_tab === 'Verification') return 'Verification';
      if (this.active_tab === 'Requests') return 'Requests';
      if (this.active_tab === 'Documents') return 'Documents';
      if (this.active_tab === 'E-Signing') return 'E-Signing';
      if (this.active_tab === 'Invoices') return 'Invoices';

      return 'none';
    },
  },
  mounted() {
    this.fetch_assigned_widgets().then(() => {
      const saved_tab = sessionStorage.getItem('active_tab');
      if (saved_tab) {
        this.active_tab = saved_tab;
        this.selectedDropdown = saved_tab;
      } else if (this.visible_tabs.length > 0) {
        this.select_tab(this.visible_tabs[0].id);
      }
      this.fetch_main_sections_tabs();
    });
    this.get_application_status();
  },

  methods: {

    get_id_from_route_or_storage(name) {
      let from_route = null;

      switch (name) {
        case "application_id":
          from_route = this.$route?.query?.application_id ?? null;
          break;
        case "profile_role_form_id":
          from_route = this.$route?.query?.profile_role_form_id ?? null;
          break;
        case "form_main_section_id":
          from_route = this.$route?.query?.form_main_section_id ?? null;
          break;
        case "entity_profile_id":
          from_route = this.$route?.query?.entity_profile_id ?? null;
          break;
        default:
          return null; // not allowed
      }

      let from_storage = null;
      try {
        if (typeof window !== "undefined" && window.sessionStorage) {
          from_storage = window.sessionStorage.getItem(name);
        }
      } catch (err) {
        // sessionStorage may be blocked/unavailable (e.g., Safari Private Mode, SSR)
        from_storage = null;
      }

      const raw = from_route ?? from_storage ?? null;
      if (raw == null || raw === "") return null;

      const n = Number(raw);
      return Number.isNaN(n) ? raw : n;
    },

    save_edited_entity() {
      const payload = {
        entity_id: this.entity_profile_id,
        name: this.current_edit_entity.name
      };

      axios.post(EDIT_ENTITY_NAME_URL, payload, { headers: this.headers })
        .then(() => {
          this.entity_name = payload.name;
          sessionStorage.setItem("entity_name", payload.name);
          this.show_edit_entity_modal = false;
          this.show_success("Entity name updated successfully.");
        })
        .catch(error => {
          const message =
            error?.response?.data?.message ||
            error.message ||
            "Failed to update entity name.";
          this.show_error(message);
        });
    },


    open_edit_entity_modal() {
      this.current_edit_entity.name = this.entity_name || "";
      this.show_edit_entity_modal = true;
    },


    select_tab(id) {
      this.active_tab = id;
      this.selectedDropdown = id; // auto-expand matching accordion
      sessionStorage.setItem('active_tab', id);
    },

    toggle_dropdown(id) {
      this.selectedDropdown = this.selectedDropdown === id ? null : id;
    },

    set_active_tab(tab) {
      this.active_main_tab = tab;
      sessionStorage.setItem('active_tab', tab);
    },

    is_db_main_section_tab(id) {
      return typeof id === 'string' && id.startsWith('ms-'); // ms-<id>
    },

    dropdown_forms_id(id) {
      if (!this.is_db_main_section_tab(id)) return null;
      const raw = id.split('-')[1];
      return Number(raw);
    },

    tab_label(id) {
      const all = [...this.visible_tabs, ...this.db_tabs];
      return (all.find(t => t.id === id)?.label) || 'Form';
    },

    fetch_assigned_widgets() {
          const request_params = {
            entity_profile_id: this.entity_profile_id,
          };

          return axios
            .get(GET_ASSIGNED_WIDGETS, {
              params: request_params,
              headers: this.headers,
            })
            .then(({ data }) => {
              // Populate all_tabs
              this.all_tabs = data.map(item => ({
                id: item.widget.widget_name,
                label: item.widget.widget_display_name,
                has_dropdown: true,
              }));

              // Populate dropdown_options
              this.dropdown_options = Object.fromEntries(
                data.map(item => [
                  item.widget.widget_name,
                  [{ value: item.widget.widget_name, label: item.widget.widget_display_name }]
                ])
              );

              this.assigned_tabs = [...this.all_tabs];
              this.visible_tabs = this.assigned_tabs
            })
            .catch(error => {
              const message =
                error?.response?.data?.message ||
                error.message ||
                "Failed to load widgets";
              this.show_error(message);
            });
        },

    fetch_main_sections_tabs() {
      const params = {
        application_id: this.application_id,
        entity_profile_id: this.entity_profile_id,
      };

      axios.get(GET_TABS, { params, headers: this.headers })
        .then(res => {
          this.application_form_id = res.data.data.application_form_id;
          const rows = res?.data?.data.data || [];

          const dynamic_tabs = rows.map(t => ({
            id: `ms-${t.id}`,
            label: t.name,
            _fmsId: t.id,
          }));

          const application_forms_index = this.visible_tabs.findIndex(t => t.id === 'application_forms');
          if (application_forms_index !== -1) {
            this.visible_tabs.splice(application_forms_index + 1, 0, ...dynamic_tabs);
          } else {
            this.visible_tabs.push(...dynamic_tabs);
          }

          this.db_tabs = dynamic_tabs;
        })
        .catch(e => {
          this.show_error?.(e?.response?.data?.message || e.message || 'Failed to load tabs');
        });
    },

    get_application_status() {
      const params = {
        application_id: this.application_id,
      };

      axios.get(GET_APPLICATION_STATUS, { params, headers: this.headers })
        .then(response => {
          this.application_status = response.data.application_status;
        })
        .catch(() => {
          this.show_error?.('Failed to retrieve application status');
        });
    },
  }
}